import { render, staticRenderFns } from "./ImageProvider.vue?vue&type=template&id=09223c3f"
import script from "./ImageProvider.vue?vue&type=script&lang=ts"
export * from "./ImageProvider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports